import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="video-sections"
export default class extends Controller {
  static targets = ["inputItem", "videoPlayer", "progressBar"]
  static values = { 
    currentSection: { type: Number, default: null },
    videoId: String
  }

  connect() {
    // Listen for player time updates (events bubble from video-player)
    this._onTimeUpdate = (e) => {
      if (!this.activeSection) return
      const { currentTime } = e.detail
      const start = this.activeSection.start
      const secDuration = this.activeSection.duration || 0
      if (secDuration <= 0) return
      const end = start + secDuration
      const clamped = Math.min(Math.max(currentTime, start), end)
      let percent = ((clamped - start) / secDuration) * 100
      percent = Math.max(0, Math.min(100, percent))
      const bar = this.progressBarTargets[this.activeSection.index]
      if (bar) bar.value = percent
    }
    document.addEventListener('video-player:timeupdate', this._onTimeUpdate)

    // Listen for moment selections from other cards to collapse/pause this one
    this._onGlobalMomentSelected = (e) => {
      const originCard = e.target.closest('[data-controller~="video-sections"]')
      if (originCard === this.element) return
      this.collapseAllMoments()
      const vc = this.videoController
      if (vc && typeof vc.pauseVideo === 'function') {
        vc.pauseVideo().catch(() => {})
      }
    }
    document.addEventListener('video-sections:moment-selected', this._onGlobalMomentSelected)
  }

  // Get the video-player controller
  get videoController() {
    return this.hasVideoPlayerTarget ? 
      this.application.getControllerForElementAndIdentifier(this.videoPlayerTarget, "video-player") : 
      null
  }

  // Action: Jump to timestamp and update accordion state
  jumpToTimestamp(event) {
    const timestamp = parseInt(event.currentTarget.dataset.timestamp)
    const sectionIndex = parseInt(event.currentTarget.dataset.sectionIndex) || 0
    const duration = parseInt(event.currentTarget.dataset.duration) || 0
    
    let input = event.currentTarget.querySelector('input[type="radio"]')
    let selected = input.checked
    if (this.currentSectionValue == sectionIndex && selected) {
      // If the input is already checked, we don't need to do anything
      input.checked = false
      this.videoController.pauseVideo()
      this.currentSectionValue = null // Reset current section value
      this.activeSection = null
      return
    }
    // Update accordion state immediately, regardless of video operations
    this.currentSectionValue = sectionIndex
    this.activeSection = { index: sectionIndex, start: timestamp, duration }
    // Notify other cards that a moment was selected here
    this.dispatch('moment-selected', { bubbles: true, cancelable: false, detail: { index: sectionIndex } })
    this.videoController.seekAndPlay(timestamp).catch((error) => {
      console.error('Error jumping to timestamp or playing video:', error)
    })
  }

  pauseVideo(e) {
    // Prevent row click toggling when the pause icon is clicked
    if (e) e.stopPropagation()
    
    // if (e?.detail.videoId != this.videoIdValue) {
    //   this.inputItemTargets.forEach((item) => {
    //     item.checked = false
    //   })
    // }
    // this.inputItemTargets.forEach((item) => {
    //   item.checked = false
    // })
  }

  disconnect() {
    if (this._onTimeUpdate) {
      document.removeEventListener('video-player:timeupdate', this._onTimeUpdate)
    }
    if (this._onGlobalMomentSelected) {
      document.removeEventListener('video-sections:moment-selected', this._onGlobalMomentSelected)
    }
  }

  // Listen to player time updates and update progress for active section
  videoPlayerTargetConnected() {
    const vc = this.videoController
    if (!vc) return
    // Handle custom events dispatched by video-player controller
    this._onTimeUpdate = (e) => {
      if (!this.activeSection) return
      const { currentTime, duration } = e.detail
      const start = this.activeSection.start
      const end = start + (this.activeSection.duration || 0)
      // Compute section-local progress (0-100)
      let percent = 0
      if (this.activeSection.duration > 0) {
        const clamped = Math.min(Math.max(currentTime, start), end)
        percent = ((clamped - start) / this.activeSection.duration) * 100
        percent = Math.max(0, Math.min(100, percent))
      }
      const bar = this.progressBarTargets[this.activeSection.index]
      if (bar) bar.value = percent
    }
    // Attach listener on the player element
    this.videoPlayerTarget.addEventListener('video-player:timeupdate', this._onTimeUpdate)
  }

  videoPlayerTargetDisconnected() {
    if (this._onTimeUpdate && this.videoPlayerTarget) {
      this.videoPlayerTarget.removeEventListener('video-player:timeupdate', this._onTimeUpdate)
    }
  }

  // Collapse all moments in this card and reset state
  collapseAllMoments() {
    this.inputItemTargets.forEach((item) => { item.checked = false })
    this.currentSectionValue = null
    this.activeSection = null
  }
}
